import { cn } from "@/lib/utils";

export type MLView = "grid" | "list";

interface MLToggleViewProps {
  className?: string;
  value: MLView;
  onChange(newVal: MLView): void;
}

export function MLToggleView({
  className,
  value,
  onChange,
}: MLToggleViewProps) {
  return (
    <div
      className={cn(
        "inline-flex gap-0.5 p-0.5 rounded-lg bg-neutral-50",
        className
      )}
    >
      <button
        onClick={() => onChange("grid")}
        className={cn(
          "h-8 w-8 rounded-md flex items-center justify-center transition-all",
          value === "grid"
            ? "bg-white shadow-sm"
            : "bg-neutral-50 hover:bg-neutral-100"
        )}
        aria-label="Grid view"
        type="button"
      >
        <i
          className={cn(
            "fa-solid fa-grid-2 text-base",
            value === "grid" ? "text-blue-500" : "text-neutral-700"
          )}
        />
      </button>

      <button
        onClick={() => onChange("list")}
        className={cn(
          "h-8 w-8 rounded-md flex items-center justify-center transition-all",
          value === "list"
            ? "bg-white shadow-sm"
            : "bg-neutral-50 hover:bg-neutral-100"
        )}
        aria-label="List view"
        type="button"
      >
        <i
          className={cn(
            "fa-solid fa-bars text-base",
            value === "list" ? "text-blue-500" : "text-neutral-700"
          )}
        />
      </button>
    </div>
  );
}
